/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DashboardConfiguration {
    getFixupPrototypeFunction() { return DashboardConfiguration.fixupPrototype; }

    static newInstance(model: Partial<DashboardConfiguration>): DashboardConfiguration {
        let obj = Object.assign(new DashboardConfiguration(), model);
        DashboardConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DashboardConfiguration>): DashboardConfiguration {
        if (!model) return null;
        return DashboardConfiguration.newInstance(<DashboardConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DashboardConfiguration) {
        if (!obj) return;

        models.DashboardConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DashboardConfiguration): boolean {
        Object.setPrototypeOf(obj, DashboardConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.portalFilter) {
            models.FilterWidgetConfiguration.fixupPrototype(this.portalFilter);
        }
        if (this.bannerSegments) {
            for (let val of this.bannerSegments) {
                models.DashboardBannerSegment.fixupPrototype(val);
            }
        }
        if (this.widgets) {
            for (let val of this.widgets) {
                models.WidgetComposition.fixupPrototype(val);
            }
        }
        if (this.filterScope) {
            for (let val of this.filterScope) {
                models.DashboardScopeNode.fixupPrototype(val);
            }
        }
        if (this.savedViews) {
            for (let val of this.savedViews) {
                models.SavedView.fixupPrototype(val);
            }
        }
    }

    title: string;

    description: string;

    showTitle: boolean;

    widgetPrimaryColor: string;

    widgetSecondaryColor: string;

    /**
     * Flavor of the dashboard
     */
    flavor: models.DashboardFlavor;

    /**
     * Menu the dashboard was created from. Dashboards created from TokenOps carry 'tokenops'; every other dashboard, including ones saved before this field existed, is 'self'.
     */
    source: models.DashboardSource;

    /**
     * Cloud provider for the dashboard. If not specified, the dashboard is considered multi-cloud.
     */
    cloud: models.CloudServiceName;

    platform: Array<models.Platforms>;

    saas: Array<models.SaasServiceName>;

    aiServices: Array<string>;

    clusterType: Array<string>;

    bannerSegments: Array<models.DashboardBannerSegment>;

    widgets: Array<models.WidgetComposition>;

    portalFilter: models.FilterWidgetConfiguration;

    /**
     * Scope for the data available in the dashboard
     */
    filterScope: Array<models.DashboardScopeNode>;

    savedViews: Array<models.SavedView>;

    /**
     * If not specified, the dashboard is considered eagerly evaluated
     */
    serviceAccountEvaluationMode: models.ServiceAccountEvaluationMode;

}
